import styled from "@emotion/styled";
import { DateTimeFormatter, LocalDateTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import AnimatedModal from "./AnimatedModal";
import { AppButton } from "./Generic/AppButton";

export interface PromptFutureVisitModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  visitStartDateTime: LocalDateTime;
}

const PromptFutureVisitModal = (props: PromptFutureVisitModalProps) => {
  const title = (
    <PromptFutureVisitModal.Title>
      {translate(STRINGS.THE_VISIT_HAS_NOT_STARTED_YET)}
    </PromptFutureVisitModal.Title>
  );
  const visitDate = props.visitStartDateTime
    .toLocalDate()
    .format(DateTimeFormatter.ofPattern("MM/dd"));
  const visitTime = props.visitStartDateTime
    .toLocalTime()
    .format(DateTimeFormatter.ofPattern("HH:mm"));
  const message = translate(STRINGS.THIS_IS_A_FUTURE_VISIT)
    .replace("{start_date}", visitDate)
    .replace("{start_time}", visitTime);
  const actions = (
    <AppButton variant="filled" color="primary" onClick={props.onRequestClose}>
      {translate(STRINGS.OK)}
    </AppButton>
  );

  return (
    <AnimatedModal
      actions={actions}
      animation={<PromptFutureVisitModal.Root />}
      animationOffset={50}
      headline={title}
      isOpen={props.isOpen}
      message={message}
      onRequestClose={props.onRequestClose}
    />
  );
};

PromptFutureVisitModal.Root = styled.div`
  background: url("../assets/future-visit.svg") no-repeat center center / cover;
  border-radius: 16px;
  overflow: hidden;
  height: 295px;
`;

PromptFutureVisitModal.Title = styled.div`
  margin: 16px 0 8px;
  font-size: 19px;
  font-weight: 800;
  text-align: center;
`;

export default PromptFutureVisitModal;
